import { GetterTree } from 'vuex';

import { State } from './state';
import IFilter from '../models/filter-model';
import IPanel from '../models/panel-model';
import { IConfig } from '../models/config-model';
import { PanelFilterWidgetService } from '../services/panel-filter-widget-services';

export default <GetterTree<State, any>>{
  getActiveFilters: (state): IFilter[] => {
    return state.filters.filter(f=>f.options.some(o=>o.checked))
  },

  totalResults: (state): Number => {
    return state.panels.filter(p=>p.isActive).length;
  },
  getPanels: (state): IPanel[] => {
    return state.panels;
  },
  getFilters: (state): IFilter[] => {
    return state.filters;
  },
  getConfig: (state): IConfig => {
    return state.config;
  },
  getPanelFilterWidgetService(state): PanelFilterWidgetService  {
    return state.panelFilterWidgetService;
},
}
